import type { AskLine } from './askTakiClient.js';

/** Conserve les messages exacts du premier appel quand une réponse reprend. */
export function askTakiHistory(
  turns: readonly (AskLine & { id?: string })[],
  original?: readonly AskLine[],
): AskLine[] {
  const source = original ?? turns.slice(-20);
  return source.map(({ role, text }) => ({ role, text }));
}
